module.exports = "<h2 class=\"section-title\">{{INITIALIZING_TITLE}}</h2>\r\n<p>{{INITIALIZING_DESCRIPTION}}</p>\r\n";